import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import DropdownList from 'react-widgets/lib/DropdownList';


import BaseInput from '../BaseInput';


import omitProps from '../../../utils/omitProps';
import { fieldProps } from '../../../propTypes';

const propTypes = exact({
  label: PropTypes.string.isRequired,
  componentProps: PropTypes.object,
  ...fieldProps,
});


const defaultProps = {
  componentProps: {},
};


const DropdownListAdapter = omitProps(['className'])(DropdownList);


const DropdownListInput = (props) => {
  const {
    label,
    componentProps,
    input,
    meta,
  } = props;

  return (
    <BaseInput
      label={label}
      input={input}
      meta={meta}
      componentClass={DropdownListAdapter}
      componentProps={componentProps}
    />
  );
};


DropdownListInput.propTypes = propTypes;


DropdownListInput.defaultProps = defaultProps;


export default DropdownListInput;
